var exports = {
  "nM": "xfd349460--5e657b--row",
  "_8": "xfd349460--5e657b--img",
  "UU": "xfd349460--5e657b--name",
  "h5": "xfd349460--5e657b--status",
  "O5": "xfd349460--5e657b--offers",
  "nf": "xfd349460--5e657b--link",
};

module.exports = exports;
